const THEME_KEY = 'icare-connect-theme';

export function systemTheme() {
  if (typeof window === 'undefined' || !window.matchMedia) {
    return 'light';
  }
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function getStoredTheme() {
  try {
    const value = localStorage.getItem(THEME_KEY);
    if (value === 'dark' || value === 'light') {
      return value;
    }
  } catch (error) {
    // private mode / blocked storage
  }
  return null;
}

export function resolveTheme() {
  return getStoredTheme() || systemTheme();
}

export function applyTheme(theme) {
  const next = theme === 'dark' ? 'dark' : 'light';
  if (typeof document !== 'undefined') {
    document.documentElement.setAttribute('data-theme', next);
    document.documentElement.style.colorScheme = next;
  }
  return next;
}

export function setTheme(theme) {
  const next = applyTheme(theme);
  try {
    localStorage.setItem(THEME_KEY, next);
  } catch (error) {
    // ignore
  }
  return next;
}

export function clearThemeOverride() {
  try {
    localStorage.removeItem(THEME_KEY);
  } catch (error) {
    // ignore
  }
  return applyTheme(systemTheme());
}

export function toggleTheme() {
  return setTheme(resolveTheme() === 'dark' ? 'light' : 'dark');
}

export function initTheme() {
  const theme = applyTheme(resolveTheme());
  if (typeof window !== 'undefined' && window.matchMedia) {
    const media = window.matchMedia('(prefers-color-scheme: dark)');
    const onChange = (event) => {
      if (!getStoredTheme()) {
        applyTheme(event.matches ? 'dark' : 'light');
      }
    };
    if (media.addEventListener) {
      media.addEventListener('change', onChange);
    } else if (media.addListener) {
      media.addListener(onChange);
    }
  }
  return theme;
}

export function clearDocumentTheme() {
  if (typeof document === 'undefined') {
    return;
  }
  document.documentElement.removeAttribute('data-theme');
  document.documentElement.style.colorScheme = '';
}
